import { useContext } from "react";
import InfoContext from "../../context/InfoContext";
import { useState } from "react";

export function useInfo() {
    const { setInfo } = useContext(InfoContext);
    const [current, setCurrent] = useState(null)
    // если priority != 'high' не перезаписываем предыдущее сообщение
    return function info(message, type = 'success', priority = 'high') {
        if (priority == 'high') {
            setInfo({ type, show: true, message });
            setCurrent(message);
        }
        else {
            if (!current) {
                setInfo({ type, show: true, message });
                setCurrent(message);
            }
        }
        setTimeout(
            () => {
                setInfo({ show: false, message: '' })
                setCurrent(null);
            }
            , 6000
        );
    }
}